import axios from 'axios';
import {subPath} from "@/subpath.config";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.response.use(
    response => response,
    async error => {
      if (error.response && error.response.status === 403) {
        window.location.href = `${subPath}/error/403`;
      }
      return Promise.reject(error);
    }
);

export default api;
